<template>
  <router-view />
</template>

<script>
  export default {
    name: 'ConfigurazioniIndex',
    data: () => ({
      expandOnHover: false,
    }),
  }
</script>
